import {
    Box,
    FormControl,
    FormControlLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import { useActividadesContext } from "../../UmmIACategories/Hook/useActividades";

const TipoEvaluacion = () => {
  const { promptData, setPromptData } = useActividadesContext();

  const evaluacionValue = promptData?.tipo_evaluacion ?? "";

  const handleTipoEvaluacionChange = (event) => {
    const selectedTipoEvaluacion = event.target.value;

    setPromptData((prevData) => ({
      ...prevData,
      tipo_evaluacion: selectedTipoEvaluacion,
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} mb={3}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          Tipo de evaluación *
        </Typography>
      </Box>
      <Grid sx={{ display: "flex", flexDirection: "column" }}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="niveles de desempeño"
            name="tipo_evaluacion"
            value={evaluacionValue}
            onChange={handleTipoEvaluacionChange}
          >
            <FormControlLabel
              value="autoevaluacion"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Autoevaluación
                </Typography>
              }
            />
            <FormControlLabel
              value="coevaluacion"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Coevaluación
                </Typography>
              }
            />
            <FormControlLabel
              value="autoevaluacion y coevaluacion"
              control={<Radio sx={{ color: "#336B87" }} />}
              label={
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "0.8rem",
                    color: "#336B87",
                  }}
                >
                  Autoevaluación y coevaluación
                </Typography>
              }
            />
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default TipoEvaluacion;
